import React from 'react';

interface TextProps extends React.InputHTMLAttributes<HTMLInputElement> {
  minWidth?: number; // in ch units
  className?: string;
  textVariant?: string;
  borderVariant?: string;
  type?: 'text' | 'password' | 'email' | 'url' | 'search' | 'tel';
}

const getBootstrapColor = (variant?: string) => {
  if (!variant) return undefined;
  return `var(--bs-${variant})`;
};

const Text = ({
  value,
  minWidth = 1,
  className,
  style,
  placeholder,
  textVariant,
  borderVariant,
  type = 'text',
  ...props
}: TextProps) => {
  let textToMeasure = value;

  if (!value && placeholder) {
    textToMeasure = placeholder;
  }

  const length = typeof textToMeasure === 'string' ? textToMeasure.length : 0;
  const effectiveWidth = Math.max(length, minWidth);

  const color = getBootstrapColor(textVariant);
  const borderColor = getBootstrapColor(borderVariant);

  return (
    <input
      type={type}
      value={value}
      placeholder={placeholder}
      style={{
        background: 'transparent',
        border: `1px dashed ${borderColor || 'var(--bs-border-color, #666)'}`,
        color: color || 'var(--bs-body-color, inherit)',
        fontFamily: 'inherit',
        padding: '0.5rem 1rem',
        display: 'inline-block',
        width: `calc(${effectiveWidth}ch + 3rem)`, // Account for padding (2rem) + extra buffer
        transition: 'width 0.3s ease-out',
        ...style,
      }}
      className={['of-themed-input', className].filter(Boolean).join(' ')}
      {...props}
    />
  );
};

export default Text;
